import { Slider, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCurrentSubTab } from '../../../redux/actions/adminSideMenuAction';
import Helmet from 'react-helmet'
import './AdminLangTrans.scss'
import { database } from '../../../utils/firebase';
import LangComponent from './LangComponent';



const AdminLangTrans = () => {

    const [languageData, setLanguageData] = useState([]);
    const [allLive, setAllLive] = useState(false);

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCurrentSubTab('s2trans'))
    }, [dispatch])

    useEffect(() => {
        if (languageData.every(el => el.live === true)) {
            setAllLive(true)
        } else {
            setAllLive(false)
        }
    }, [allLive, languageData])

    useEffect(() => {
        const langRef = database.ref('Languages')
        langRef.on('value', (el) => {
        let eData = []
        for (let id in el.val()) {
            eData.push({id, ...el.val()[id]})
        }
        setLanguageData(eData)
        
       })
    }, [])

    
  
    const handleGoLiveAll = () => {
        languageData.forEach(el => {
            const langRef = database.ref('Languages').child(el.id)
            langRef.update({
                live: true
            })
        })
    }

    const handleAllLive = () => {
        languageData.forEach(el => {
            const langRef = database.ref('Languages').child(el.id)
            langRef.update({
                live: false
            })
        })
    }
    

    


    return (
        <div className="admin-lang-trans">
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Translation | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Translation Page" />
            </Helmet>
            <div className="top">
                <h2>Language Translation</h2>
                {allLive? <button className="all-live" onClick={handleAllLive}>LIVE</button> : <button onClick={handleGoLiveAll}>GO LIVE ALL</button>}
                
                
            </div>

            <div className="lang-trans-view">

                
                
                {languageData.map(el => {
                    return (
                    <LangComponent url={el.audioUrl} language={el.language} id={el.id} live={el.live} />
                    )
                })}
                
   

            </div>
        </div>
    )
}

export default AdminLangTrans